import { LinkCodeComponent } from './link-code/link-code.component';
export var listcodeRoutes = [
    {
        path: 'list-code',
        component: LinkCodeComponent
    }
];
var ListCodeRoutingModule = (function () {
    function ListCodeRoutingModule() {
    }
    return ListCodeRoutingModule;
}());
export { ListCodeRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/list-code/list-code-routing.module.ts.pre-build-optimizer.js